// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"splatNumberInput_wrapper__YpPGZ","input":"splatNumberInput_input__Azl8w"};